import React, { PureComponent } from "react";

export default class SimpleInlineSpinner extends PureComponent {
  render() {
    return <span className="simple-spinner" />;
  }
}
